@if (selectedBluePrintField) {
<div class="div-right-panel-component">
  <form #myForm="ngForm">
    <fieldset [disabled]="isReadOnly" style="border: none; padding: 0; margin: 0">
      <mat-form-field>
        <mat-label>Name (Type:{{ selectedBluePrintField.fieldType }})</mat-label>
        <input matInput #inputName maxlength="255" name="name" required (blur)="onNameBlur()" (focus)="selectName()"
          (keyup)="onChange()" type="text" [(ngModel)]="selectedBluePrintField.name" />
      </mat-form-field>

      <mat-form-field>
        <mat-label>Description</mat-label>
        <input matInput name="description" type="text" [(ngModel)]="selectedBluePrintField.description" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Label</mat-label>
        <input matInput name="label" type="text" [placeholder]="selectedBluePrintField.name" [(ngModel)]="selectedBluePrintField.label" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Tooltip</mat-label>
        <input matInput name="tooltip" type="text" [placeholder]="selectedBluePrintField.name" [(ngModel)]="selectedBluePrintField.tooltip" />
      </mat-form-field>

      <div class="calendar-field-group" style="margin: 16px 0; display: flex; flex-direction: column; gap: 8px;">
        <label for="datetimePicker" style="font-size: 12px; color: rgba(0, 0, 0, 0.6);">Choose default date time</label>
        <p-datepicker #datetimeFieldInput inputId="datetimePicker" appendTo="body" [showTime]="true" [showIcon]="true"
          [hideOnDateTimeSelect]="false" hourFormat="24" name="datetimeField" [(ngModel)]="tempDate"
          (ngModelChange)="onCalendarDateChange($event)" dateFormat="dd M yy">
          <p-footer>
            <div style="display: flex; justify-content: space-between; padding: 10px">
              <button type="button" mat-button (click)="onClearDate()">Clear</button>
              <button type="button" mat-raised-button color="primary" (click)="onSetDate()">Set</button>
            </div>
          </p-footer>
        </p-datepicker>
      </div>

      <div class="checkbox-field">
        <mat-checkbox [(ngModel)]="datetimeField.isRequired" [checked]="datetimeField.isRequired" name="isRequired">Is
          required?</mat-checkbox>
      </div>

      <div class="checkbox-field">
        <mat-checkbox [(ngModel)]="datetimeField.isReadOnly" [checked]="datetimeField.isReadOnly" name="fieldisReadOnly">Is
          read-only?</mat-checkbox>
      </div>
    </fieldset>

    <div class="save-button-div" *ngIf="!isReadOnly">
      <button mat-raised-button color="primary" (click)="saveWork()"
        [disabled]="!myForm.form.valid || !myForm.form.dirty">Save</button>
    </div>
  </form>
</div>
}